import React from 'react';

import useShopRunnerWatcher from 'hooks/useShopRunnerWatcher';

const ShoprunnerLineItemIcon = () => {
  const { isLoggedIn } = useShopRunnerWatcher();
  return (
    isLoggedIn && (
      <div className="md:mt-1">
        <sr-eligible></sr-eligible>
      </div>
    )
  );
};

export default ShoprunnerLineItemIcon;
